import { render, staticRenderFns } from "./ReservationFailed.vue?vue&type=template&id=7cdd0848&scoped=true"
import script from "./ReservationFailed.vue?vue&type=script&lang=ts"
export * from "./ReservationFailed.vue?vue&type=script&lang=ts"
import style0 from "./ReservationFailed.vue?vue&type=style&index=0&id=7cdd0848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd0848",
  null
  
)

export default component.exports